import React from "react";

import { css } from "@emotion/css";
import { ApiError, QueryErrorFallbackProps } from "@steto-care/steto-query";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/card/Card.tsx";
import { CardContent } from "@/uiKit/atoms/card/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/card/CardHeader.tsx";
import { ShowApiError } from "@/uiKit/molecules/ShowApiError.tsx";

export const HandledErrorCard: React.FC<QueryErrorFallbackProps> = ({ error }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  if (error instanceof ApiError) {
    return (
      <Card className={styles.card}>
        <CardHeader title={t("errors.title")} classes={{ title: styles.title }} />
        <CardContent>
          <ShowApiError
            errorMapping={{
              PAGE_NOT_FOUND: t("errors.pageNotFound"),
            }}
            error={error?.data}
          />
        </CardContent>
      </Card>
    );
  }

  return <ShowApiError errorMapping={{}} />;
};

const makeStyles = (theme: Theme) => ({
  title: css({
    color: theme.palette.error.dark,
  }),
  card: css({
    margin: theme.spacing(8),
  }),
});
